export const AGE_GROUPS = [
  { id: "under18", label: "<18", min: -Infinity, max: 17 },
  { id: "18-35", label: "18-35", min: 18, max: 35 },
  { id: "36-50", label: "36-50", min: 36, max: 50 },
  { id: "51-65", label: "51-65", min: 51, max: 65 },
  { id: "over65", label: ">65", min: 66, max: Infinity },
];

export const getPatientAge = (patient) => {
  if (patient?.age != null && !Number.isNaN(Number(patient.age))) {
    return Number(patient.age);
  }

  if (patient?.birthDate) {
    const birth = new Date(patient.birthDate);
    if (Number.isNaN(birth.getTime())) return null;

    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age -= 1;
    }
    return age;
  }

  return null;
};

export const buildAgeDistribution = (patients) => {
  const counts = Object.fromEntries(AGE_GROUPS.map((group) => [group.id, 0]));
  let validCount = 0;

  for (const patient of patients) {
    const age = getPatientAge(patient);
    if (age == null) continue;

    validCount += 1;
    const group = AGE_GROUPS.find(
      (item) => age >= item.min && age <= item.max
    );
    if (group) counts[group.id] += 1;
  }

  return {
    total: validCount,
    groups: AGE_GROUPS.map((group) => ({
      ...group,
      count: counts[group.id],
      percentage:
        validCount > 0
          ? Math.round((counts[group.id] / validCount) * 100)
          : 0,
    })),
  };
};
